<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useAuthStore } from './stores/auth';
import { Toaster } from '@/components/ui/sonner';

const authStore = useAuthStore();

const isReady = ref(false);
onMounted(async () => {
  await authStore.reAuth();
  isReady.value = true;
})

</script>

<template>
  <RouterView v-if="isReady" />
  <div v-else class="w-screen h-screen grid place-items-center overflow-x-hidden">
    <div class="text-xl font-medium text-muted-foreground">Initializing...</div>
  </div>
  <Toaster close-button position="bottom-right" />
</template>
